import { defineNuxtPlugin, useRuntimeConfig } from '#app'

let buryScriptPromise: Promise<void> | null = null

const loadBuryScript = (url: string) => {
  if (typeof document === 'undefined' || !url) {
    return Promise.resolve()
  }
  if (document.querySelector('script[data-mj-bury]')) {
    return buryScriptPromise ?? Promise.resolve()
  }

  buryScriptPromise = new Promise<void>((resolve) => {
    const schedule = () => {
      const script = document.createElement('script')
      script.src = url
      script.defer = true
      script.dataset.mjBury = 'true'
      script.onload = () => resolve()
      script.onerror = () => resolve()
      document.body.appendChild(script)
    }

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => schedule(), { timeout: 3000 })
    } else {
      window.setTimeout(schedule, 2000)
    }
  })

  return buryScriptPromise
}

const noopBury = {
  async init() {
    return null
  },
}

export default defineNuxtPlugin((nuxtApp) => {
  try {
    const config = useRuntimeConfig()

    nuxtApp.hook('app:mounted', () => {
      if (nuxtApp.$compatFeatures?.bury === false) return

      const initBury = () => {
        nuxtApp.$bury.init({ activity_name: 'mojiwww' }).then((bury: unknown) => {
          if (bury) (window as Window & { _bury?: unknown })._bury = bury
        })
      }
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => initBury(), { timeout: 5000 })
      } else {
        window.setTimeout(initBury, 3000)
      }
    })

    return {
      provide: {
        bury: {
          async init(options?: { activity_name?: string }) {
            await loadBuryScript(config.public.buryUrl as string)
            if (!window.Mjburyspot) {
              console.warn('Mjburyspot 未加载')
              return null
            }
            return window.Mjburyspot.init(['shence', 'loge'], {
              shence: {},
              loge: {},
              ...(options || {}),
            })
          },
        },
      },
    }
  } catch (e) {
    console.warn('[bury] plugin failed safe:', e)
    return { provide: { bury: noopBury } }
  }
})
